import UIComponent from "../ui/component";

export class SpeakerRename extends UIComponent {
    init() {
        this.updateDeleteButtons();
        
        this.speakerItem.forEach((item) => {
            item.speakerSelect.on("click", () => {
                this.selectSpeaker(item);
            });

            item.speakerEdit.on("click", (e) => {
                e.stopPropagation();
                const nameEl = item.speakerSelect.speakerName.el();
                nameEl.classList.add("speaker-edit-active");
                this.showCheckOnly(item);

                const onNameClick = () => {
                    nameEl.removeEventListener("click", onNameClick);
                    this.editSpeakerName(item);
                };
                nameEl.addEventListener("click", onNameClick);
            });

            item.speakerDelete.on("click", () => {
                this.deleteSpeaker(item);
            });
        });
    }

    editSpeakerName(item) {
        const nameEl = item.speakerSelect.speakerName.el();

        const oldSpan = nameEl;
        const currentName = oldSpan.textContent.replace(/\s+/g, " ").trim();

        this.showCheckOnly(item);

        const input = document.createElement("input");
        input.type = "text";
        input.className = "speaker-edit-input speaker-name";
        input.value = currentName;

        oldSpan.replaceWith(input);
        input.focus();
        input.select();

        input.addEventListener("blur", () => {
            const newName =
                input.value.replace(/\s+/g, " ").trim() || currentName;
            oldSpan.textContent = newName;
            oldSpan.classList.remove("speaker-edit-active");
            input.replaceWith(oldSpan);
            item.speakerSelect.checkIcon.addClass("d-none");
            this.parent.saveEdit();
          
        });

        input.addEventListener("keydown", (ev) => {
            if (ev.key === "Enter") {
                ev.preventDefault();
                input.blur();
            }
        });
    }

    deleteSpeaker(item) {
        item.remove();
        this.speakerItem = this.speakerItem.filter((i) => i !== item);
        this.updateDeleteButtons();
    }

    updateDeleteButtons() {
        this.speakerItem.forEach((item) => {
            const deleteBtn = item.speakerDelete;
            if (this.speakerItem.length === 1) {
                deleteBtn.addClass("d-none");
            } else {
                deleteBtn.removeClass("d-none");
            }
        });
    }

    selectSpeaker(item) {
        const hasInput = item.speakerSelect.el().querySelector("input");
        if (hasInput) return;

        this.speakerItem.forEach((el) => {
            el.speakerSelect.removeClass("speaker-select-active");
            el.speakerSelect.checkIcon.addClass("d-none");
            el.speakerSelect.speakerName.removeClass("speaker-edit-active");
        });

        item.speakerSelect.addClass("speaker-select-active");
        item.speakerSelect.checkIcon.removeClass("d-none");
    }

    showCheckOnly(item) {
        this.speakerItem.forEach((item) => {
            item.speakerSelect.checkIcon.addClass("d-none");
            item.speakerSelect.speakerName.removeClass("speaker-edit-active");
            item.speakerSelect.removeClass("speaker-select-active");
        });
        item.speakerSelect.speakerName.addClass("speaker-edit-active");
        item.speakerSelect.checkIcon.removeClass("d-none");
    }
}
